import React from 'react';

import { PageContainer, FooterToolbar } from '@ant-design/pro-layout';
import ProTable from '@ant-design/pro-table';

import { Avatar, Tag, Button, Space, message } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';

import DropOption from '../../components/DropOption';

import moment from 'moment';
import momentDe from 'moment/locale/de';

import { bimServerApi, errorHandler } from '../../store/apis/bim.server.api';

import UserModal from './Modal/UserModal';

export default class UsersView extends React.Component {
  tableRef = React.createRef();
  constructor() {
    super();

    moment.locale('de', momentDe);

    this.state = {
      visible: false,
      deletion: false,
      current: undefined,
      selectedRows: [],
    };
  }

  /* ========================================================================== */
  /*                                    Modal                                   */
  /* ========================================================================== */

  showModal = () => {
    this.setState({
      visible: true,
      current: undefined,
    });
  };
  showEditModal = (item) => {
    this.setState({
      visible: true,
      current: item,
    });
  };
  showDeleteModal = (item) => {
    this.setState({
      visible: true,
      current: item,
      deletion: true,
    });
  };
  handleCancel = () => {
    this.setState({
      visible: false,
      deletion: false,
    });
  };

  handleSubmit = (formValues) => {
    const { current } = this.state;
    if (current) {
      this.updateUser(formValues);
    } else {
      this.registerUser(formValues);
    }
    this.setState({
      visible: false,
      deletion: false,
    });
  };
  handleDelete = () => {
    this.deleteUser(this.state.current);
    this.setState({
      visible: false,
      deletion: false,
    });
  };
  handleDeleteItems = (users) => {
    users.map((user) => {
      this.deleteUser(user);
    });
    this.tableRef.current?.reloadAndRest?.();
  };

  deleteUser = (current) => {
    bimServerApi.delete(`/api/users/${current.id}`).then(
      (response) => {
        message.success(`Löschen erfolgreich...`);
        this.tableRef.current?.reloadAndRest?.();
      },
      (err) => {
        errorHandler(err);
        this.tableRef.current?.reloadAndRest?.();
      },
    );
  };
  registerUser = (formValues) => {
    bimServerApi.post('/api/users/', formValues).then(
      (response) => {
        message.success(`Registration erfolgreich...`);
        this.tableRef.current?.reloadAndRest?.();
      },
      (err) => {
        errorHandler(err);
        this.tableRef.current?.reloadAndRest?.();
      },
    );
  };
  updateUser = (formValues) => {
    const { current } = this.state;
    bimServerApi.put(`/api/users/${current.id}`, formValues).then(
      () => {
        message.success(`Registration erfolgreich...`);
        this.tableRef.current?.reloadAndRest?.();
      },
      (err) => {
        errorHandler(err);
        this.tableRef.current?.reloadAndRest?.();
      },
    );
  };

  /* ========================================================================== */
  /*                           DropOption Handle Click                          */
  /* ========================================================================== */

  handleMenuClick = (record, e) => {
    switch (e.key) {
      case '1':
        //Edit
        this.showEditModal(record);
        break;
      case '2':
        //Delete
        this.showDeleteModal(record);
        break;
    }
  };

  get columns() {
    return [
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar',
        width: 100,
        search: false,
        render: (data) => <Avatar src={`data:image/jpeg;base64,${data}`} />,
      },
      {
        title: 'Vorname',
        dataIndex: 'firstName',
        key: 'firstName',
        copyable: true,
      },
      {
        title: 'Nachname',
        dataIndex: 'lastName',
        key: 'lastName',
        copyable: true,
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        copyable: true,
      },
      {
        title: 'Organisation',
        dataIndex: 'organisation',
        key: 'organisation',
        copyable: true,
        renderFormItem: (_, { defaultRender }) => {
          return defaultRender(_);
        },
        render: (_, record) => {
          return record.organisation ? `${record.organisation.name}` : `-`;
        },
      },
      {
        title: 'Status',
        dataIndex: 'status',
        filters: true,
        onFilter: true,
        valueType: 'select',
        valueEnum: {
          active: {
            text: 'Aktiv',
            status: 'Success',
          },
          disabled: {
            text: 'Disabled',
            status: 'Error',
          },
          'unverified-email': {
            text: 'Nicht verifiziert',
            status: 'Processing',
          },
        },
      },
      {
        title: 'Role',
        dataIndex: 'role',
        filters: true,
        onFilter: true,
        valueType: 'select',
        valueEnum: {
          user: {
            text: 'User',
          },
          admin: {
            text: 'Admin',
          },
          root: {
            text: 'Root',
          },
        },
        renderFormItem: (_, { defaultRender }) => {
          return defaultRender(_);
        },
        render: (_, record) => (
          <Tag color={record.role !== 'root' ? (record.role === 'user' ? 'green' : 'yellow') : 'red'} key={record.role}>
            {record.role}
          </Tag>
        ),
      },
      {
        title: 'Subscription',
        dataIndex: 'subscription',
        filters: true,
        onFilter: true,
        valueType: 'select',
        valueEnum: {
          test: {
            text: 'Test',
          },
          basic: {
            text: 'Basic',
          },
          professional: {
            text: 'Professional',
          },
          premium: {
            text: 'Premium',
          },
        },
      },
      {
        title: 'Erstellt',
        key: 'createdAt',
        dataIndex: 'createdAt',
        valueType: 'date',
        search: false,
        sorter: (a, b) => {
          const aa = moment(a.createdAt);
          const bb = moment(b.createdAt);
          return aa - bb;
        },
      },
      {
        title: 'Last Login',
        key: 'lastLogin',
        dataIndex: 'lastLogin',
        valueType: 'date',
        search: false,
        sorter: (a, b) => {
          const aa = moment(a.lastLogin);
          const bb = moment(b.lastLogin);
          return aa - bb;
        },
      },
      {
        title: 'Object Id',
        dataIndex: 'id',
        key: 'id',
        copyable: true,
        search: false,
      },
      {
        title: 'Action',
        valueType: 'option',
        fixed: 'right',
        render: (text, record, _, action) => [
          <DropOption
            onMenuClick={(e) => this.handleMenuClick(record, e)}
            menuOptions={[
              { key: '1', name: `Bearbeiten`, icon: <EditOutlined /> },
              {
                key: '2',
                name: `Löschen`,
                icon: <DeleteOutlined />,
                danger: true,
              },
            ]}
          />,
        ],
      },
    ];
  }

  render() {
    const { selectedRows, visible, current, deletion } = this.state;
    return (
      <PageContainer>
        <ProTable
          actionRef={this.tableRef}
          rowKey="id"
          search={{
            labelWidth: 'auto',
          }}
          columns={this.columns}
          headerTitle={
            <Space>
              <span>User Table</span>
            </Space>
          }
          rowSelection={{
            onChange: (_, selectedRows) => this.setState({ selectedRows: selectedRows }),
          }}
          toolBarRender={() => [
            <Button key="button" icon={<PlusOutlined />} type="primary" onClick={() => this.showModal()}>
              Add
            </Button>,
          ]}
          request={(params, sort, filter) => {
            delete params['current'];
            delete params['pageSize'];
            const queryString = Object.keys(params)
              .map((key) => key + '=' + params[key])
              .join('&');
            return new Promise(async (resolve, reject) => {
              bimServerApi.get(`/api/users/?${queryString}`).then(
                (response) => {
                  resolve({ data: response.data.users, success: true });
                },
                (err) => {
                  reject({ data: null, success: false });
                },
              );
            });
          }}
        />
        {selectedRows?.length > 0 && (
          <FooterToolbar
            extra={
              <div>
                Ausgewählt: <a style={{ fontWeight: 600 }}>{selectedRows.length}</a> User
              </div>
            }
          >
            <Button
              type="primary"
              onClick={async () => {
                await this.handleDeleteItems(selectedRows);
                this.setState({ selectedRows: [] });
              }}
            >
              Löschen
            </Button>
          </FooterToolbar>
        )}
        <UserModal
          deletion={deletion}
          current={current}
          visible={visible}
          onCancel={this.handleCancel}
          onSubmit={this.handleSubmit}
          onDelete={this.handleDelete}
        />
      </PageContainer>
    );
  }
}
